/* SPH – Musterstücke im Warenkorb mit Bild und Titel der gewählten Platte zeigen */
(function () {
  if (!document.querySelector('.sph-cart') && !document.querySelector('cart-items')) return;

  function apply(cart) {
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      var ref = p['Muster f\u00fcr'];
      var img = p['_bild'];
      var url = p['_url'];
      if (!ref) return;

      var row = document.querySelector('[data-key="' + it.key + '"]');
      if (!row) return;

      var im = row.querySelector('img');
      if (im && img) {
        im.src = img;
        im.srcset = '';
        im.alt = ref;
      }
      var link = row.querySelector('a[href]');
      if (link && url) link.setAttribute('href', url);

      var t = row.querySelector('.sph-ci__t');
      if (t) {
        t.textContent = ref;
        if (url) t.setAttribute('href', url);
      }
      var v = row.querySelector('.sph-ci__v');
      if (!v) {
        v = document.createElement('span');
        v.className = 'sph-ci__v';
        if (t && t.parentNode) t.parentNode.insertBefore(v, t.nextSibling);
      }
      v.textContent = 'Musterst\u00fcck \u00b7 bis zu 3 Muster';

      row.querySelectorAll('.sph-ci__p').forEach(function (el) {
        if (/Muster f\u00fcr/i.test(el.textContent)) el.remove();
      });
    });
  }

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(apply)
    .catch(function () {});
})();
